// extracted by mini-css-extract-plugin
export var header = "_s4-1";
export var maskBottom = "_s4-6";
export var maskMiddle = "_s4-7";
export var maskTop = "_s4-5";
export var root = "_s4-0";
export var scrollDownButton = "_s4-3";
export var scrollDownButtonHidden = "_s4-4";
export var viewport = "_s4-2";